
import React, { useState, useRef, useEffect } from 'react';
import './Footer.css'; // Import the CSS file
import { useAppSettings } from '../hooks/useAppSettings';

const Footer = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const modalRef = useRef(null);
  const { appSettings } = useAppSettings();

  const openModal = (e) => {
    e.preventDefault();
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Close modal when clicking outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        // Check if the click is on the trigger button to avoid immediate closing
        if (event.target.id !== 'myid') {
          closeModal();
        }
      }
    };

    if (isModalOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isModalOpen]);

  return (
    <>
      <footer>
        <div className="footer-container">
          {/* Footer columns */}
          <div className="footer-column">
            <h4>DATA BOT FOR STAFF AND STUDENTS</h4>
            <ul>
              <li><span>{appSettings?.schoolName}</span></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>ABOUT</h4>
            <ul>
              <li><a href="/about/background">Background</a></li>
              <li><a href="/about/management">The Management</a></li>
              <li><a href="/about/objectives">Objectives</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>STUDENTS</h4>
            <ul>
              <li><a href="/guides/account">Account Guide</a></li>
              <li><a href="/signup">Create Account</a></li>
              <li><a href="/registration/student">Stud. Dept. Reg.</a></li>
              <li><a href="/pay-fees">Pay School Fees</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>DEPARTMENTS</h4>
            <ul>
              <li><a href="/guides/account">Account Guide</a></li>
              <li><a href="/staff/hods">H.O.D.s</a></li>
              <li><a href="/staff">Staff</a></li>
              <li><a href="/staff/clerks">eClerks</a></li>
              <li><a href="/forms/nna">NNA Form</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>OTHER LINKS</h4>
            <ul>
              <li><a href="/faqs">FAQs</a></li>
              <li><a href="/resources/educational">Educational</a></li>
              <li><a href="/admissions/e-verify">E-Verify</a></li>
              <li><a href="/downloads/public">Public Files</a></li>
              <li><a href="/support">Support Desks</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>ANNEX</h4>
            <ul>
              <li><span style={{ color: '#a84c32' }}>Connect with us</span></li>
              <li>
                <a href="https://chat.whatsapp.com/GVZLcsYJ8V415a0IqPlTZG" title="Join WhatsApp Group">
                  <img src="https://bspdatabot.name.ng/ssPortal/images/icons/1whatsapp.png" alt="WhatsApp" /> Admissions WhatsApp
                </a>
              </li>
              <li>
                <a href="https://benpolyonline.edu.ng" target="_blank" rel="noopener noreferrer">
                  <span className="badge" style={{ backgroundColor: '#000099', padding: '6px 10px', borderRadius: '3px' }}>Main Site</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
         © {appSettings?.schoolSession} {appSettings?.schoolName} :: All Rights Reserved ::
          <button id="myid" onClick={openModal} className="link-button">Privacy Policy</button>
        </div>

        {isModalOpen && (
          <div id="myModal" className="modal2" style={{ display: 'block' }}>
            <div className="modal-content2" ref={modalRef}>
              <span className="close2" onClick={closeModal}>&times;</span>
              <h2>Privacy Policy</h2>
              <p>
                Holy See Bright Academy is committed to protecting the privacy of its users. Personal data is collected only for official purposes and safeguarded with strict security measures.
              </p>
              <h3>Scope</h3>
              <ul>
                <li>This policy applies to all users of bspdatabot.name.ng.</li>
                <li>External websites are not covered by this policy.</li>
              </ul>
              <h3>Security</h3>
              <ul>
                <li>All user data is encrypted and in transit and at rest.</li>
              </ul>
              <p>
                Contact: <a href="mailto:coordinator@bspdatabot.name.ng" style={{ color: '#004080' }}>coordinator@bspdatabot.name.ng</a>
              </p>
            </div>
          </div>
        )}
      </footer>
    </>
  );
};

export default Footer;
